import { useModalState } from "@clipboard-health/ui-react";
import { Button } from "@mui/material";
import { GeneralLocationPrimerModal } from "@src/app/openShifts/urgentShifts/generalLocationPrimerModal/generalLocationPrimerModal";
import { requestFullLocationAccess } from "@src/app/openShifts/urgentShifts/utils";

export function LocationPermissionsButton() {
  const {
    modalIsOpen: generalLocationPrimerModalIsOpen,
    openModal: openGeneralLocationPrimerModal,
    closeModal: closeGeneralLocationPrimerModal,
  } = useModalState();

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={() => {
          openGeneralLocationPrimerModal();
        }}
      >
        <b>Enable Location Permissions</b>
      </Button>

      <GeneralLocationPrimerModal
        isOpen={generalLocationPrimerModalIsOpen}
        onDidDismiss={closeGeneralLocationPrimerModal}
        onDeny={closeGeneralLocationPrimerModal}
        onAllowLocationClick={() => {
          closeGeneralLocationPrimerModal();
          void requestFullLocationAccess();
        }}
      />
    </>
  );
}
